module.exports = __webpack_public_path__ + "media/images/icons/Hvezdicky/starFilled-71fcb8d2840277de7c7cde7ed85ba1e7.svg";